module.exports = __webpack_public_path__ + "static/media/capri-1.8edae666.jpg";